import api from './api';

/**
 * Fetch Curva S per cantiere
 * - Usa credenziali (cookie di sessione PHP)
 * - URL compatibile con /server e /server/index.php
 */
export const getCurvaS = async (cantiereId) => {
  const url = `/dashboard/${cantiereId}/curva-s`;
  try {
    const res = await api.get(url);
    return res.data;
  } catch (error) {
    const status = error.response?.status || 'Error';
    const message = error.response?.data || error.message;
    throw new Error(`CurvaS GET ${status}: ${message}`);
  }
};
